import HttpService from '../../infra/http/AxiosConfig'
import CancelablePromise from '../../functions/CancelablePromise';

const resource = "organizacoes"
const paymentBillNotificationLastSeenStoragePath = "ultimo-dia-visto-notificacao-boleto"

export const organizacaoService = {
  getPaged(page, pageSize, filter = '', termsAndConditions = null, acceptAppPayment = null, suspended = null, acceptWhatsApp = null, orderDate = false) {
    const url = `${resource}/${page}/${pageSize}`;
    const request = HttpService.AxiosClient.get(url, { params: { filtro: filter, termosECondicoes: termsAndConditions, aceitaPagtoApp: acceptAppPayment, suspensa: suspended, recebeMensagemWhatsApp: acceptWhatsApp, ordenarData: orderDate } })
    return CancelablePromise(request)
  },
  getById(id) {
    return HttpService.AxiosClient.get(`${resource}\\${id}`)
  },
  getDropdownList() {
    return  HttpService.AxiosClient.get(`${resource}/dropdownlist`);
  },
  create(organization) {
    return HttpService.AxiosClient.post(resource, organization);
  },
  update(organization) {
    return HttpService.AxiosClient.put(resource, organization);
  },
  delete(organizationId) {
    return HttpService.AxiosClient.delete(`${resource}/${organizationId}`);
  },
  getOperationParameters(idOrganizacao, pagina = 1, quantidade = 10){
    return CancelablePromise(HttpService.AxiosClient.get(`${resource}\\parametroOperacao\\${idOrganizacao}\\${pagina}\\${quantidade}`))
  },
  getResales() {
    return HttpService.AxiosClient.get(`${resource}/revendas`)
  },
  acceptTermsAndConditions() {
    return HttpService.AxiosClient.put(`${resource}\\aceitarTermosECondicoes`);
  },
  declineTermsAndConditions() {
    return HttpService.AxiosClient.put(`${resource}\\recusarTermosECondicoes`);
  },
  getBilletNotificationLastSeenDay() {
    const dateString = localStorage.getItem(paymentBillNotificationLastSeenStoragePath)
    return dateString ?? new Date(dateString)
  },
  updateBilletNotificationLastSeenDay(date) {
    const parsedDay = date.toISOString()
    localStorage.setItem(paymentBillNotificationLastSeenStoragePath, parsedDay)
  },
  closeResales() {
    return HttpService.AxiosClient.put(`${resource}\\fechar-revendas`)
  }
}
